import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'vc-localisation-modal',
  templateUrl: './localisation-modal.component.html',
  styleUrls: ['./localisation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocalisationModalComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {}
}
